export default __webpack_public_path__ + "static/media/glrc-course.plant_based_essentials.188278ad.png";